import { DataService } from '../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, UiWaitReadySO, PmTechnicalIP, userFilterOption } from '../../shared/misc-classes';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-gantt-summary',
  templateUrl: './gantt-summary.component.html',
  styleUrls: ['./gantt-summary.component.css']
})
export class GanttSummaryComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  _soObjList: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated: boolean = false;

  isLoading: boolean = false;

  isRevMonthFilterSelectedGantt: boolean = false;
  isInvMonthFilterSelectedGantt: boolean = false;
  isManfMonthFilterSelectedGantt: boolean = false;
  isManfStrategyFilterSelectedGantt: boolean = false;
  isOrderTypeFilterSelectedGantt: boolean = false;
  isRegionFilterSelectedGantt: boolean = false;
  isRelayConfigFilterSelectedGantt: boolean = false;
  isUserSelectionFilterSelectedGantt: boolean = false;

  userSelectionType: userFilterOption = userFilterOption.All;
  userDeptIdSelectedGantt:string[]= [];
  revMonthFilter: monthFilter;
  invMonthFilter: monthFilter;
  manfMonthFilter: monthFilter;
  manfStrategyIndex: number = 0;
  orderTypeIndex: number = 0;
  regionIndex: number = 0;
  relayConfigIndex: number = 0;
  regionSelToken: string = "0,0";
  marketingEnggArray:string[]= [];
  projManagerArray:string[]= [];
  projEnggArray:string[]= [];
  elecDesignEnggArray:string[]= [];
  mechDesignEnggArray:string[]= [];
  c30EnggArray:string[]= [];
  userTypeArray:any[]= [];

  headerArrayQty: any = [];
  bodyArrayQty: any = [];
  headerArrayMinr: any = [];
  bodyArrayMinr: any = [];

  constructor(public _dataService: DataService) { }

  ngOnInit() {
    this._dataService.currPageName = 'Factory Loading-R12';
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }


  saveSettingsToCookies() {
    this._dataService.setCookie('s-revmonth-sel-gantt', this.isRevMonthFilterSelectedGantt ? "1" : "0");
    if (this.isRevMonthFilterSelectedGantt) {
      this._dataService.setCookie('s-revmonth-val-gantt', this.revMonthFilter.getCookieStr());
    }
    this._dataService.setCookie('s-invoicingmonth-sel-gantt', this.isInvMonthFilterSelectedGantt ? "1" : "0");
    if (this.isInvMonthFilterSelectedGantt) {
      this._dataService.setCookie('s-invoicingmonth-val-gantt', this.invMonthFilter.getCookieStr());
    }
    this._dataService.setCookie('s-manfmonth-sel-gantt', this.isManfMonthFilterSelectedGantt ? "1" : "0");
    if (this.isManfMonthFilterSelectedGantt) {
      this._dataService.setCookie('s-manfmonth-val-gantt', this.manfMonthFilter.getCookieStr());
    }
    this._dataService.setCookie('s-manfstra-sel-gantt', this.isManfStrategyFilterSelectedGantt ? "1" : "0");
    if (this.isManfStrategyFilterSelectedGantt) {
      this._dataService.setCookie('s-manfstra-val-gantt', this.manfStrategyIndex + '');
    }
    this._dataService.setCookie('s-userdept-sel-gantt', this.isUserSelectionFilterSelectedGantt ? "1" : "0")
    if (this.isUserSelectionFilterSelectedGantt) {
      this._dataService.setCookie('s-userdept-val-gantt', this.userDeptIdSelectedGantt +'')
    }
    this._dataService.setCookie('s-ordertype-sel-gantt', this.isOrderTypeFilterSelectedGantt ? "1" : "0");
    if (this.isOrderTypeFilterSelectedGantt) {
      this._dataService.setCookie('s-ordertype-val-gantt', this.orderTypeIndex + '');
    }
    this._dataService.setCookie('s-relayconfig-sel-gantt', this.isRelayConfigFilterSelectedGantt ? "1" : "0");
    if (this.isRelayConfigFilterSelectedGantt) {
      this._dataService.setCookie('s-relayconfig-val-gantt', this.relayConfigIndex + '');
    }
    this._dataService.setCookie('s-region-sel-gantt', this.isRegionFilterSelectedGantt ? "1" : "0");
    if (this.isRegionFilterSelectedGantt) {
      // this._dataService.setCookie('s-region-val', this.regionIndex + '');
      this._dataService.setCookie('s-region-val-gantt', this.regionSelToken);
    }

  }
  loadSettingsFromCookies() {
    let _tmpRevMonthSel: string = this._dataService.getCookie('s-revmonth-sel-gantt');
    if (_tmpRevMonthSel) {
      this.isRevMonthFilterSelectedGantt = (_tmpRevMonthSel == "1");

      let _tmpRevMonthVal: string = this._dataService.getCookie('s-revmonth-val-gantt');
      if (_tmpRevMonthVal) {
        this.revMonthFilter = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
      }
    }
    let _tmpInvMonthSel: string = this._dataService.getCookie('s-invoicingmonth-sel-gantt');
    if (_tmpInvMonthSel) {
      this.isInvMonthFilterSelectedGantt = (_tmpInvMonthSel == "1");

      let _tmpInvMonthVal: string = this._dataService.getCookie('s-invoicingmonth-val-gantt');
      if (_tmpInvMonthVal) {
        this.invMonthFilter = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
      }
    }
    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-gantt');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedGantt = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-gantt');
      if (_tmpManfMonthVal) {
        this.manfMonthFilter = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }
    let _tmpManfStraSel: string = this._dataService.getCookie('s-manfstra-sel-gantt');
    if (_tmpManfStraSel) {
      this.isManfStrategyFilterSelectedGantt = (_tmpManfStraSel == "1");

      let _tmpManfStraVal: string = this._dataService.getCookie('s-manfstra-val-gantt');
      if (_tmpManfStraVal) {
        this.manfStrategyIndex = parseInt(_tmpManfStraVal, 10);
      }
    }
    let _tmpUserDeptSel: string = this._dataService.getCookie('s-userdept-sel-gantt');
    if (_tmpUserDeptSel) {
      this.isUserSelectionFilterSelectedGantt = (_tmpUserDeptSel == "1");

      let _tmpUserDeptVal: string = this._dataService.getCookie('s-userdept-val-gantt');
      if (_tmpUserDeptVal) {
        this.userDeptIdSelectedGantt = _tmpUserDeptVal.split(",");
        this.extractUserDeptSelToken(_tmpUserDeptVal.split(","));
      }
    }
    let _tmpOrderTypeSel: string = this._dataService.getCookie('s-ordertype-sel-gantt');
    if (_tmpOrderTypeSel) {
      this.isOrderTypeFilterSelectedGantt = (_tmpOrderTypeSel == "1");

      let _tmpOrderTypeVal: string = this._dataService.getCookie('s-ordertype-val-gantt');
      if (_tmpOrderTypeVal) {
        this.orderTypeIndex = parseInt(_tmpOrderTypeVal, 3);
      }
    }
    let _tmpRelayConfigSel: string = this._dataService.getCookie('s-relayconfig-sel-gantt');
    if (_tmpRelayConfigSel) {
      this.isRelayConfigFilterSelectedGantt = (_tmpRelayConfigSel == "1");

      let _tmpRelayConfigVal: string = this._dataService.getCookie('s-relayconfig-val-gantt');
      if (_tmpRelayConfigVal) {
        this.relayConfigIndex = parseInt(_tmpRelayConfigVal, 10);
      }
    }
    let _tmpRegionSel: string = this._dataService.getCookie('s-region-sel-gantt');
    if (_tmpRegionSel) {
      this.isRegionFilterSelectedGantt = (_tmpRegionSel == "1");

      let _tmpRegionVal: string = this._dataService.getCookie('s-region-val-gantt');
      if (_tmpRegionVal) {
        // this.regionIndex = parseInt(_tmpRegionVal , 10);
        this.extractRegionSelToken(_tmpRegionVal, true);
      }
    }

    let _currDate: Date = new Date();
    if (this.revMonthFilter == null) {
      this.revMonthFilter = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }
    if (this.invMonthFilter == null) {
      this.invMonthFilter = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }
    if (this.manfMonthFilter == null) {
      this.manfMonthFilter = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }
  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr2: Array<SalesOrder>) => {
        this._soObjList = _soObjAr2.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }


  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isRevMonthFilterSelectedGantt = false;
    this.isInvMonthFilterSelectedGantt = false;
    this.isManfMonthFilterSelectedGantt = false;
    this.isManfStrategyFilterSelectedGantt = false;
    this.isUserSelectionFilterSelectedGantt = false;
    this.isOrderTypeFilterSelectedGantt = false;
    this.isRegionFilterSelectedGantt = false;
    this.isRelayConfigFilterSelectedGantt = false;
    this.orderTypeIndex = 0;
    this.relayConfigIndex = 0;
    this.manfStrategyIndex = 0;
    this.userDeptIdSelectedGantt = [];
    this.userTypeArray = [];
    this.marketingEnggArray = [];
    this.projManagerArray = [];
    this.projEnggArray = [];
    this.elecDesignEnggArray = [];
    this.mechDesignEnggArray = [];
    this.c30EnggArray = [];

    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }

  extractUserDeptSelToken(_tmpToken){
    let _tmpUserArray = [];
    let _tmpUserArrayUniq = [];
    let _tokens:Array<string> = _tmpToken;
    let _tmpmarketingEnggArray = [];
    let _tmpprojManagerArray = [];
    let _tmpprojEnggArray = [];
    let _tmpelecDesignEnggArray = [];
    let _tmpmechDesignEnggArray = [];
    let _tmpc30EnggArray = [];

    for(let i = 0; i<_tokens.length;i++){
        let _user = _tokens[i].split(':');
        let _userType:userFilterOption = userFilterOption.All;
        _userType =  parseInt(_user[0],10);        
        if(_userType == userFilterOption.MarketingEngineer){
         _tmpUserArray.push(_userType);
         _tmpmarketingEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.ProjectManager){
         _tmpUserArray.push(_userType);
         _tmpprojManagerArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.ProjectEngineer){
         _tmpUserArray.push(_userType);
         _tmpprojEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.ElectricDesignEngineer){
         _tmpUserArray.push(_userType);
         _tmpelecDesignEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.MechanicalDesignEngineer){
         _tmpUserArray.push(_userType);
         _tmpmechDesignEnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.C30Engineer){
         _tmpUserArray.push(_userType);
         _tmpc30EnggArray.push(_user[1]);
        }
        else if(_userType == userFilterOption.All){
          _tmpUserArray = [];
          _tmpUserArray.push(_userType);
        }
    }

    _tmpUserArray.forEach((item) => {  
      if(!_tmpUserArrayUniq.includes(item)){  
         _tmpUserArrayUniq.push(item);  
      }  
   }); 
   
   this.userTypeArray = _tmpUserArrayUniq;
   this.marketingEnggArray = _tmpmarketingEnggArray;
   this.projManagerArray = _tmpprojManagerArray
   this.projEnggArray = _tmpprojEnggArray;
   this.elecDesignEnggArray = _tmpelecDesignEnggArray;
   this.mechDesignEnggArray = _tmpmechDesignEnggArray;
   this.c30EnggArray = _tmpc30EnggArray;
  }
  userSelected(_event){
    this.extractUserDeptSelToken(_event.value);
    this.filterRows();

  }
  extractRegionSelToken(_tmpToken: string, _updateSource: boolean): boolean {
    let _tokens: Array<string> = _tmpToken.split(',');
    if (_tokens.length == 2) {
      let regionType = parseInt(_tokens[0], 10);
      //Comparing with 0 because 0 means 'All' category is are selected
      if (regionType != 0) {
        this.regionIndex = parseInt(_tokens[1], 10);
      }
      else this.regionIndex = 0; // TO SHOW ALL THE VALUES WHEN 'ALL' IS SELECTED
      if (_updateSource == true) {
        this.regionSelToken = _tmpToken
      }
      return true;
    }
    return false;
  }
  regionSelected() {
    if (this.extractRegionSelToken(this.regionSelToken, false)) {
      this.filterRows();
    }
  }

  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  private displaySOwithNoSSO() {
    if (
      this.isRevMonthFilterSelectedGantt == true || this.isInvMonthFilterSelectedGantt == true || this.isManfMonthFilterSelectedGantt == true || this.isManfStrategyFilterSelectedGantt == true ||
      this.isOrderTypeFilterSelectedGantt == true || this.isRelayConfigFilterSelectedGantt == true ||
      // this.isRegionFilterSelected == true || // COMMENTED BECAUSE THE TOTAL AMMED. PO VAL WAS DIFFEREING WHEN THE FILTER WAS APPLIED 
      this.userTypeArray.includes(userFilterOption.ElectricDesignEngineer) ||
      this.userTypeArray.includes(userFilterOption.MechanicalDesignEngineer) ||
      this.userTypeArray.includes(userFilterOption.C30Engineer)

    ) {
      return false;
    }

    return true;
  }



  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _selectedMonth: Date = new Date();
    let _dateRanges: any = [];
    let _dateRangesMonths: any = [];
    let _tmpHeaderArrayQty: any = [];
    let _tmpBodyArrayQty: any = [];
    let _tmpHeaderArrayMinr: any = [];
    let _tmpBodyArrayMinr: any = [];
    let _tmpZN1: any = [];
    let _tmpZN1Cons: any = [];
    let _tmpZS9: any = [];
    let _tmpZS9Cons: any = [];
    let _tmpZS1: any = [];
    let _tmpZS1Cons: any = [];
    let _tmpZS1DBB: any = [];
    let _tmpZS1DBBCons: any = [];
    let _tmpZS2: any = [];
    let _tmpZS2Cons: any = [];

    let _tmpQty: number = 0;
    let _tmpMinr: number = 0;


    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    let todayDate = new Date();

    for (var i = 0; i < this._soObjList.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList[i];


      let _isSOPassedFilter: boolean = this.isSaleOrderTestPassed(_tmpSO);
      if (_isSOPassedFilter == true) {
        var _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            if (this.isManfMonthFilterSelectedGantt == true) {
              _selectedMonth = _tmpSSO.manufacturingMonth;
            }
            else if (this.isInvMonthFilterSelectedGantt == true) {
              _selectedMonth = _tmpSSO.invoicingmonth;
            }
            else if (this.isRevMonthFilterSelectedGantt == true) {
              _selectedMonth = _tmpSSO.revenueMonth;
            }
            else {
              _selectedMonth = _tmpSSO.manufacturingMonth;
            }

            if (_selectedMonth != null && this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient) != '-') {
              ////// LOGIC

              _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                if (_equpList.includes(e.equipmentType)) {
                  var temp: number = parseInt(e.panelQuantity, 10);
                  if (temp > 0) {
                    _tmpQty += temp;

                  }
                  var temp1: number = parseFloat(e.contractualValue);
                  if (temp1 > 0) {
                    _tmpMinr += temp1;
                  }
                }
              });
              let _month = _selectedMonth.getMonth()+1; // Month starts with 0
              switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                case "001":
                  // ZS1                   
                  _tmpZS1.push({ x: _month, y: _tmpQty, z: _tmpMinr });
                  _tmpQty = 0;
                  _tmpMinr = 0;

                  break;
                case "002":
                  //  ZS1DBB 
                  _tmpZS1DBB.push({ x: _month, y: _tmpQty, z: _tmpMinr });
                  _tmpQty = 0;
                  _tmpMinr = 0;

                  break;
                case "003":
                  // ZS2 
                  _tmpZS2.push({ x: _month, y: _tmpQty, z: _tmpMinr });
                  _tmpQty = 0;
                  _tmpMinr = 0;

                  break;
                case "004":
                  // ZN1
                  _tmpZN1.push({ x: _month, y: _tmpQty, z: _tmpMinr });
                  _tmpQty = 0;
                  _tmpMinr = 0;

                  break;
                case "005":
                  // ZS9 
                  _tmpZS9.push({ x: _month, y: _tmpQty, z: _tmpMinr });
                  _tmpQty = 0;
                  _tmpMinr = 0;

                  break;
              }

            }
          });
          _tmpSSOCounter++;

        }


      }

    }
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // MONTH SELECTION
    let _tmpFromMonth,_tmpFromYear;
    let _tmpToMonth,_tmpToYear;
    if (this.isManfMonthFilterSelectedGantt == true) {
      _tmpFromMonth = this.manfMonthFilter.fromMonth;
      _tmpFromYear= this.manfMonthFilter.fromYear;
      _tmpToMonth = this.manfMonthFilter.toMonth;
      _tmpToYear = this.manfMonthFilter.toYear;
    }
    else if (this.isInvMonthFilterSelectedGantt == true) {
      _tmpFromMonth = this.invMonthFilter.fromMonth;
      _tmpFromYear= this.invMonthFilter.fromYear;
      _tmpToMonth = this.invMonthFilter.toMonth;
      _tmpToYear = this.invMonthFilter.toYear;
    }
    else if (this.isRevMonthFilterSelectedGantt == true) {
      _tmpFromMonth = this.revMonthFilter.fromMonth;
      _tmpFromYear= this.revMonthFilter.fromYear;
      _tmpToMonth = this.revMonthFilter.toMonth;
      _tmpToYear = this.revMonthFilter.toYear;
    }
    else{
      _tmpFromMonth = 1;
      _tmpFromYear= todayDate.getFullYear(); // Just to pass a year to get Date range, has no significance
      _tmpToMonth = 12;
      _tmpToYear = todayDate.getFullYear(); // Just to pass a year to get Date range, has no significance
    }

    this.getDateRange(_tmpFromYear, _tmpFromMonth, _tmpToYear, _tmpToMonth, _dateRanges);

    if(this.isManfMonthFilterSelectedGantt == true || this.isInvMonthFilterSelectedGantt == true || this.isRevMonthFilterSelectedGantt == true){
      _tmpHeaderArrayQty.push('Product Type');
      for (let i = 0; i < _dateRanges.length; i++) {
        var a = _dateRanges[i].split('-');
        var b = a[0];
        var c = parseInt(a[1]);  
        _dateRangesMonths.push(c);   
        _tmpHeaderArrayQty.push([b,months[c- 1]].join('-'));
      }
  
      _tmpHeaderArrayMinr.push('Product Type');
      for (let i = 0; i < _dateRanges.length; i++) {
        var a = _dateRanges[i].split('-');
        var b = a[0];
        var c = parseInt(a[1]);  
        _dateRangesMonths.push(c);   
        _tmpHeaderArrayMinr.push([b,months[c- 1]].join('-'));
      }
    }
    else
    {
      _dateRangesMonths = [1,2,3,4,5,6,7,8,9,10,11,12];
      _tmpHeaderArrayQty.push('Product Type');
      _tmpHeaderArrayQty = _tmpHeaderArrayQty.concat(months);

      _tmpHeaderArrayMinr.push('Product Type');
      _tmpHeaderArrayMinr = _tmpHeaderArrayMinr.concat(months);

    }
    
    // Body
    this.groupBy3(_tmpZS1, _tmpZS1Cons);
    this.groupBy3(_tmpZS1DBB, _tmpZS1DBBCons);
    this.groupBy3(_tmpZS2, _tmpZS2Cons);
    this.groupBy3(_tmpZN1, _tmpZN1Cons);
    this.groupBy3(_tmpZS9, _tmpZS9Cons);
    
  /// QTY
    let arrZS1 = new Array(13).fill(0);
    for (let i = 0; i < _tmpZS1Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS1Cons[i].x) + 1;
      arrZS1[idx] = _tmpZS1Cons[i].y
    }
    arrZS1[0] = this._dataService.getProductVariantName('001');
    _tmpBodyArrayQty.push(arrZS1);


    let arrZS1DBB = new Array(13).fill(0);

    for (let i = 0; i < _tmpZS1DBBCons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS1DBBCons[i].x) + 1;
      arrZS1DBB[idx] = _tmpZS1DBBCons[i].y
    }
    arrZS1DBB[0] = this._dataService.getProductVariantName('002');
    _tmpBodyArrayQty.push(arrZS1DBB);

    let arrZS2 = new Array(13).fill(0);

    for (let i = 0; i < _tmpZS2Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS2Cons[i].x) + 1;
      arrZS2[idx] = _tmpZS2Cons[i].y
    }
    arrZS2[0] = this._dataService.getProductVariantName('003');
    _tmpBodyArrayQty.push(arrZS2);

    let arrZN1 = new Array(13).fill(0);

    for (let i = 0; i < _tmpZN1Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZN1Cons[i].x) + 1;
      arrZN1[idx] = _tmpZN1Cons[i].y
    }
    arrZN1[0] = this._dataService.getProductVariantName('004');
    _tmpBodyArrayQty.push(arrZN1);

    let arrZS9 = new Array(13).fill(0);

    for (let i = 0; i < _tmpZS9Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS9Cons[i].x) + 1;
      arrZS9[idx] = _tmpZS9Cons[i].y
    }
    arrZS9[0] = this._dataService.getProductVariantName('005');
    _tmpBodyArrayQty.push(arrZS9);

    /// MINR
    let arrZS1Minr = new Array(13).fill(0);
    for (let i = 0; i < _tmpZS1Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS1Cons[i].x) + 1;
      arrZS1Minr[idx] = _tmpZS1Cons[i].z.toFixed(2)
    }
    arrZS1Minr[0] = this._dataService.getProductVariantName('001');
    _tmpBodyArrayMinr.push(arrZS1Minr);


    let arrZS1DBBMinr = new Array(13).fill(0);

    for (let i = 0; i < _tmpZS1DBBCons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS1DBBCons[i].x) + 1;
      arrZS1DBBMinr[idx] = _tmpZS1DBBCons[i].z.toFixed(2)
    }
    arrZS1DBBMinr[0] = this._dataService.getProductVariantName('002');
    _tmpBodyArrayMinr.push(arrZS1DBBMinr);

    let arrZS2Minr = new Array(13).fill(0);

    for (let i = 0; i < _tmpZS2Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS2Cons[i].x) + 1;
      arrZS2Minr[idx] = _tmpZS2Cons[i].z.toFixed(2)
    }
    arrZS2Minr[0] = this._dataService.getProductVariantName('003');
    _tmpBodyArrayMinr.push(arrZS2Minr);

    let arrZN1Minr = new Array(13).fill(0);

    for (let i = 0; i < _tmpZN1Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZN1Cons[i].x) + 1;
      arrZN1Minr[idx] = _tmpZN1Cons[i].z.toFixed(2)
    }
    arrZN1Minr[0] = this._dataService.getProductVariantName('004');
    _tmpBodyArrayMinr.push(arrZN1Minr);

    let arrZS9Minr = new Array(13).fill(0);

    for (let i = 0; i < _tmpZS9Cons.length; i++) {
      let idx = _dateRangesMonths.indexOf(_tmpZS9Cons[i].x) + 1;
      arrZS9Minr[idx] = _tmpZS9Cons[i].z.toFixed(2)
    }
    arrZS9Minr[0] = this._dataService.getProductVariantName('005');
    _tmpBodyArrayMinr.push(arrZS9Minr);


    this.headerArrayQty = _tmpHeaderArrayQty;
    this.bodyArrayQty = _tmpBodyArrayQty;
    this.headerArrayMinr = _tmpHeaderArrayMinr;
    this.bodyArrayMinr = _tmpBodyArrayMinr;
    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;

    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }

  getRevMonthLabel(): string {
    if (this.isRevMonthFilterSelectedGantt == true) {
      return "Revenue Month : ";
    }
    else {
      return "Enable Revenue Month Filter";
    }
  }
  getInvMonthLabel(): string {
    if (this.isInvMonthFilterSelectedGantt == true) {
      return "Invoicing Month : ";
    }
    else {
      return "Enable Invoicing Month Filter";
    }
  }
  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedGantt == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }
  getManfStrategyLabel(): string {
    if (this.isManfStrategyFilterSelectedGantt == true) {
      return "Manufacturing Strategy : ";
    }
    else {
      return "Enable Manufacturing Strategy Filter";
    }
  }
  getOrderTypeLabel(): string {
    if (this.isOrderTypeFilterSelectedGantt == true) {
      return "Order Type : "
    }
    else {
      return "Enable Order Type Filter"
    }
  }
  getRelayConfigLabel(): string {
    if (this.isRelayConfigFilterSelectedGantt == true) {
      return "Relay Configuration: "
    }
    else {
      return "Enable Relay Config. Filter"
    }
  }
  getRegionLabel(): string {
    if (this.isRegionFilterSelectedGantt == true) {
      return "Cluster - Region : "
    }
    else {
      return "Enable Cluster- Region Filter"
    }
  }
  getUserFilterLabel(): string {
    if (this.isUserSelectionFilterSelectedGantt == true) {
      return "User Selection : ";
    }
    else {
      return "Enable User Selection Filter";
    }
  }
  getRevFromMonthName(): string {
    if (this.revMonthFilter) {
      return this.revMonthFilter.fromMonthName;
    }
    return '';
  }
  getRevToMonthName(): string {
    if (this.revMonthFilter) {
      return this.revMonthFilter.toMonthName;
    }
    return '';
  }
  getInvFromMonthName(): string {
    if (this.invMonthFilter) {
      return this.invMonthFilter.fromMonthName;
    }
    return '';
  }
  getInvToMonthName(): string {
    if (this.invMonthFilter) {
      return this.invMonthFilter.toMonthName;
    }
    return '';
  }
  getManfStrategyName(): string {
    if (this.manfStrategyIndex >= 0 && this.manfStrategyIndex < this._dataService.manufacturtingStrategy.length) {
      return this._dataService.manufacturtingStrategy[this.manfStrategyIndex].manufacturtingStrategyName;
    }
    return '';
  }
  manfStrategyPrev() {
    if (this.manfStrategyIndex > 0) {
      this.manfStrategyIndex--;
    }
    else {
      this.manfStrategyIndex = this._dataService.manufacturtingStrategy.length - 1;
    }
    this.filterRows();
  }
  manfStrategyNext() {
    if (this.manfStrategyIndex < this._dataService.manufacturtingStrategy.length - 1) {
      this.manfStrategyIndex++;
    }
    else {
      this.manfStrategyIndex = 0;
    }
    this.filterRows();
  }
  getorderTypeName(): string {
    if (this.orderTypeIndex >= 0 && this.orderTypeIndex < this._dataService.ordertypes.length) {
      return this._dataService.ordertypes[this.orderTypeIndex].ordertypeName;
    }
    return '';
  }

  orderTypePrev() {
    if (this.orderTypeIndex > 0) {
      this.orderTypeIndex--;
    }
    else {
      this.orderTypeIndex = this._dataService.ordertypes.length - 1;
    }
    this.filterRows();
  }
  orderTypeNext() {
    if (this.orderTypeIndex < this._dataService.ordertypes.length - 1) {
      this.orderTypeIndex++;
    }
    else {
      this.orderTypeIndex = 0;
    }
    this.filterRows();
  }
  getrelayConfigName(): string {
    if (this.relayConfigIndex >= 0 && this.relayConfigIndex < this._dataService.relayconfigs_ui.length) {
      return this._dataService.relayconfigs_ui[this.relayConfigIndex].relayconfigName;
    }
    return '';
  }

  relayConfigPrev() {
    if (this.relayConfigIndex > 0) {
      this.relayConfigIndex--;
    }
    else {
      this.relayConfigIndex = this._dataService.relayconfigs_ui.length - 1;
    }
    this.filterRows();
  }
  relayConfigNext() {
    if (this.relayConfigIndex < this._dataService.relayconfigs_ui.length - 1) {
      this.relayConfigIndex++;
    }
    else {
      this.relayConfigIndex = 0;
    }
    this.filterRows();
  }
  getregionName(): string {
    if (this.regionIndex >= 0 && this.regionIndex < this._dataService.regions.length) {
      return this._dataService.regions[this.regionIndex].regionName;
    }
    return '';
  }

  regionPrev() {
    if (this.regionIndex > 0) {
      this.regionIndex--;
    }
    else {
      this.regionIndex = this._dataService.regions.length - 1;
    }
    this.filterRows();
  }
  regionNext() {
    if (this.regionIndex < this._dataService.regions.length - 1) {
      this.regionIndex++;
    }
    else {
      this.regionIndex = 0;
    }
    this.filterRows();
  }
  getManfFromMonthName(): string {
    if (this.manfMonthFilter) {
      return this.manfMonthFilter.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilter) {
      return this.manfMonthFilter.toMonthName;
    }
    return '';
  }

  revPrevFromMonth() {
    this.revMonthFilter.prevFromMonth12();
    this.filterRows();
  }
  revNextFromMonth() {
    this.revMonthFilter.nextFromMonth12();
    this.filterRows();
  }
  revPrevToMonth() {
    this.revMonthFilter.prevToMonth12();
    this.filterRows();
  }
  revNextToMonth() {
    this.revMonthFilter.nextToMonth12();
    this.filterRows();
  }

  InvPrevFromMonth() {
    this.invMonthFilter.prevFromMonth12();
    this.filterRows();
  }
  InvNextFromMonth() {
    this.invMonthFilter.nextFromMonth12();
    this.filterRows();
  }
  InvPrevToMonth() {
    this.invMonthFilter.prevToMonth12();
    this.filterRows();
  }
  InvNextToMonth() {
    this.invMonthFilter.nextToMonth12();
    this.filterRows();
  }

  manfPrevFromMonth() {
    this.manfMonthFilter.prevFromMonth12();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilter.nextFromMonth12();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilter.prevToMonth12();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilter.nextToMonth12();
    this.filterRows();
  }

  private isSaleOrderTestPassed(_so: SalesOrder): boolean {

    //check if so user is seleceted
    if (this.isSOUserFilterPassed(_so.marketingIP.marketingEngineerId, _so.marketingIP.projectManagerId, _so.pmCommercial.projectEngineerId) == false) return false;

    //Cluster filter
    if (this.isRegionFilterPassed(_so.marketingIP.regionId) == false) return false;

    return true;
  }
  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if sso user is seleceted
      if (this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId, _sso.enggDrawIP.mechanicalDesignEngineerId, _sso.enggDrawIP.c30EngineerId) == false) return false;

      //check if revenue month 
      if (this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
      if (this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      if (this.isManfStrategyFilterPassed(_sso.manufacturingStrategy) == false) return false;
      if (this.isRelayConfigFilterPassed(_sso.relayconfig) == false) return false;

      return true;
    });
  }

  private isRevMonthFilterPassed(_revenueMonth: Date) {
    if (this.isRevMonthFilterSelectedGantt == true && this.revMonthFilter != null) {
      if (this.revMonthFilter.isWithInFilterScope(_revenueMonth) == false) {
        return false;
      }
    }
    return true;
  }
  private isInvMonthFilterPassed(_invoicingmonth: Date) {
    if (this.isInvMonthFilterSelectedGantt == true && this.invMonthFilter != null) {
      if (this.invMonthFilter.isWithInFilterScope(_invoicingmonth) == false) {
        return false;
      }
    }
    return true;
  }
  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedGantt == true && this.manfMonthFilter != null) {
      if (this.manfMonthFilter.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }
  private isManfStrategyFilterPassed(_manfStraId: string) {
    if (this.isManfStrategyFilterSelectedGantt == true &&
      this.manfStrategyIndex >= 0 && this._dataService.manufacturtingStrategy[this.manfStrategyIndex]) {

      if (this._dataService.manufacturtingStrategy[this.manfStrategyIndex].manufacturtingStrategyId != _manfStraId) {
        return false;
      }

    }
    return true;
  }
  private isRelayConfigFilterPassed(_relayconfigId: string) {
    if (this.isRelayConfigFilterSelectedGantt == true && this.relayConfigIndex >= 0 && this._dataService.relayconfigs_ui[this.relayConfigIndex]) {
      if (this._dataService.relayconfigs_ui[this.relayConfigIndex].relayconfigId != _relayconfigId) {
        return false
      }
    }
    return true;
  }
  private isRegionFilterPassed(_regionId: string) {
    //this.regionIndex-1 is because the array index needs to match with the _regionId
    if (this.isRegionFilterSelectedGantt == true && (this.regionIndex - 1) >= 0 && this._dataService.regions[this.regionIndex - 1]) {
      if (this._dataService.regions[this.regionIndex - 1].regionId != _regionId) {
        return false
      }
    }
    return true;
  }

  private isSOUserFilterPassed(_mktgEngId: string, _projManagerId: string, _projEngId: string): boolean {
    //check for failure cases
    if(this.isUserSelectionFilterSelectedGantt == true && !this.userTypeArray.includes(userFilterOption.All)){
      if(this.userTypeArray.includes(userFilterOption.MarketingEngineer)){
        if(!this.marketingEnggArray.includes(_mktgEngId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.ProjectManager)){
        if(!this.projManagerArray.includes(_projManagerId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.ProjectEngineer)){
        if(!this.projEnggArray.includes(_projEngId)) return false;
      }
    }
    return true;
  }
  private isSSOUserFilterPassed(_elecEngId: string, _mechEnggId: string, _c30EngId: string): boolean {
    //check for failure cases
    if(this.isUserSelectionFilterSelectedGantt == true && !this.userTypeArray.includes(userFilterOption.All)){
      if(this.userTypeArray.includes(userFilterOption.ElectricDesignEngineer)){
        if(!this.elecDesignEnggArray.includes(_elecEngId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.MechanicalDesignEngineer)){
        if(!this.mechDesignEnggArray.includes(_mechEnggId)) return false;
      }
      else if(this.userTypeArray.includes(userFilterOption.C30Engineer)){
        if(!this.c30EnggArray.includes(_c30EngId)) return false;
      }
    }
    return true;
  }

  exportQty(){
    let element = document.getElementById('qty-table');
    //To remove the titles for the export of the excel      
    
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'MMM-yyyy;@'});//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
      XLSX.writeFile(wb, 'factory-loading-qty.xlsx');
     
  }
  exportMinr(){
    let element = document.getElementById('minr-table');
    //To remove the titles for the export of the excel      
    
      //Export to excel
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element,{ cellDates:true,dateNF:'MMM-yyyy;@'});//converts a DOM TABLE element to a worksheet      
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
      XLSX.writeFile(wb, 'factory-loading-minr.xlsx');
     
  }

  exportOverAll(){
    let element = document.getElementById('qty-table');
    //To remove the titles for the export of the excel      
    
    let element1 = document.getElementById('minr-table');
    //To remove the titles for the export of the excel      
    
    let worksheet_tmp1 = XLSX.utils.table_to_sheet(element,{ cellDates:true,dateNF:'MMM-yyyy;@'});
    let worksheet_tmp2 = XLSX.utils.table_to_sheet(element1,{ cellDates:true,dateNF:'MMM-yyyy;@'});
       
    let a = XLSX.utils.sheet_to_json(worksheet_tmp1, { header: 1, raw:true })
    let b = XLSX.utils.sheet_to_json(worksheet_tmp2, { header: 1, raw:true })
    
    let c:any = [['','Factory Loading - Qty']]
    let a1 = c.concat(a,['',''],[['','Factory Loading - MINR']]).concat(b)

      
    let worksheet = XLSX.utils.json_to_sheet(a1, { skipHeader: true, cellDates:true,dateNF:'MMM-yyyy;@'})
    
    const new_workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(new_workbook, worksheet, "Sheet1")
    XLSX.writeFile(new_workbook, 'factory-loading-overall.xlsx')
  }
  private groupBy3(array, result) {
    array.reduce(function (res, value) {
      if (!res[value.x]) {
        res[value.x] = { x: value.x, y: 0, z: 0 };
        result.push(res[value.x])
      }
      res[value.x].y += value.y;
      res[value.x].z += value.z;
      return res;
    }, {});
  }
  getDateRange(_startYear, _startMonth, _endYear, _endMonth, dates) {
    var startYear = _startYear;
    var endYear = _endYear;
    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : _endMonth - 1;
      var startMon = i === startYear ? _startMonth - 1 : 0;
      for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        var month = j + 1;
        var displayMonth = month;
        dates.push([i, displayMonth].join('-'));
      }
    }
    return dates;
  }

}
